<div class="page-title" [ngClass]="'page-title-' + pathName">
  <content-title [title]="'Mailings.Templates.' + pathName | translate" />
</div>

<ng-container *ngIf="rows?.length; else emptyList">
  <div class="scroll-wrapper">
    <app-mailing-template-item
      *ngFor="let row of rows"
      [project]="mailingService.project"
      [id]="row.id"
      [title]="row.name"
      [subject]="row.title"
      [content]="row.content"
      [email]="email"
    />
  </div>
</ng-container>

<ng-template #emptyList>
  <div class="mailing-page-empty-state">
    <div class="mailing-page-empty-state__text">
      {{ 'Global.emptyListState' | translate }}
    </div>
  </div>
</ng-template>
